import {
  Avatar,
  Box,
  LinkBox,
  LinkOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import {
  getFirstString,
  getHighlightValue,
  getNestedValue,
} from '../hitHelpers';
import { OpenSearchHit } from '../types';
import { OpenSearchText } from './OpenSearchText';

export const OpenSearchUser: React.FC<{
  hit: OpenSearchHit;
  viewableAttributeField: string;
}> = ({ hit, viewableAttributeField }) => {
  const attributes = getNestedValue(hit, viewableAttributeField) || {};
  const displayName = getFirstString(
    getHighlightValue(hit, 'displayName', '_highlightResult'),
    hit.displayName,
    [attributes.firstName, attributes.lastName].filter(Boolean).join(' '),
    'Member'
  );
  const userId = getFirstString(hit.userId, hit.sourceId, hit.objectID);

  return (
    <LinkBox
      as={Stack}
      direction="row"
      spacing="2"
      alignItems="center"
      p="2"
      bg="white"
      _hover={{ bg: 'gray.100' }}
      borderRadius="xl"
      cursor="pointer"
    >
      <Avatar
        size="sm"
        name={displayName.replace(/<\/?em>/g, '')}
        src={
          getFirstString(hit.profilePictureUrl, attributes.profilePictureUrl) ||
          undefined
        }
      />

      <Box>
        <LinkOverlay as={NextLink} href={`/members/${userId}`}>
          <Text noOfLines={1} textStyle="bodyStrong">
            <OpenSearchText value={displayName} />
          </Text>
        </LinkOverlay>

        {(attributes.jobTitle || attributes.company) && (
          <Text noOfLines={1} textStyle="compact" color="gray.600">
            {attributes.jobTitle}
            {attributes.jobTitle && attributes.company ? ' at ' : ''}
            {attributes.company}
          </Text>
        )}
      </Box>
    </LinkBox>
  );
};
